import React, {forwardRef} from 'react';
import {motion} from 'framer-motion';

import {Icon} from '@spothero/ui';

const FramerMotionIcon = motion(Icon);

const MotionIcon = forwardRef((props, ref) => {
    return <FramerMotionIcon {...props} ref={ref} />;
});

export default MotionIcon;
